
export default function CampaignNotes() {
  const notes = [
    '本キャンペーンの対象製品は MeVER Chair Pro v1.1 および MeVER Chair Style v1.0 です。',
    'キャンペーン期間：2026年3月31日 23:59:59（日本時間）まで。',
    '2026年4月1日より、対象製品は新価格に改定されます。キャンペーン期間中は現行価格でご予約いただけます。',
    '在庫切れの場合、MeVERオンラインショップの購入ボタンが「予約する」に切り替わります。',
    '予約時の価格は、現行価格からさらに10%OFFが適用されます。',
    'Amazonギフト券5,000円分は、予約でご購入いただいたお客様のうち先着50脚限定です。',
    'Amazonギフト券は、商品の納品完了後にご注文時のメールアドレス宛にお届けいたします。',
    '予約特典（10%OFF + Amazonギフト券）は、在庫切れ後の予約注文のみが対象となります。在庫がある場合は通常のキャンペーン価格での購入となります。',
    'キャンペーン内容は予告なく変更・終了する場合がございます。',
  ];

  const faq = [
    {
      q: 'キャンペーン価格はいつから適用されますか？',
      a: 'キャンペーン期間中（2026年3月31日まで）のご注文に適用されます。価格改定は2026年4月1日からですが、キャンペーン期間中は現行価格でお求めいただけます。',
    },
    {
      q: '予約の10%OFFはどのタイミングで適用されますか？',
      a: '在庫がなくなり、オンラインショップの購入ボタンが「予約する」に切り替わった後のご注文に適用されます。在庫がある間は、キャンペーン価格（現行価格）での通常購入となります。',
    },
    {
      q: 'Amazonギフト券はいつ届きますか？',
      a: '商品の納品が完了した後、ご注文時にご登録いただいたメールアドレス宛にお届けいたします。',
    },
    {
      q: 'なぜ価格改定が必要になったのですか？',
      a: 'MeVER Chairは発売以来、価格維持に努めてまいりましたが、昨今の急激な円安ドル高の影響により、原材料費や輸送コストが大幅に上昇しております。これ以上の価格維持が困難となり、不本意ながら価格改定をさせていただくこととなりました。',
    },
    {
      q: 'MeVER Chair Core は対象ですか？',
      a: 'Core は今回の価格改定対象外のため、本キャンペーンの対象には含まれておりません。',
    },
  ];

  return (
    <section className="py-20 sm:py-28 bg-white" aria-labelledby="campaign-notes-heading">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-12">
        {/* FAQ */}
        <div className="mb-16 sm:mb-20">
          <div className="text-center mb-10 sm:mb-14">
            <span className="inline-flex items-center gap-2 px-4 py-2 bg-black/5 text-black/60 text-xs sm:text-sm font-light tracking-[0.15em] rounded-full mb-5 sm:mb-6">
              FAQ
            </span>
            <h2 id="campaign-notes-heading" className="text-2xl sm:text-3xl md:text-4xl font-extralight text-black mb-4 tracking-[0.08em]">
              よくあるご質問
            </h2>
          </div>

          <div className="space-y-4 sm:space-y-5" itemScope itemType="https://schema.org/FAQPage">
            {faq.map((item, idx) => (
              <details
                key={idx}
                className="group bg-gray-50 rounded-xl sm:rounded-2xl overflow-hidden border border-gray-100"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
              >
                <summary className="flex items-center justify-between px-5 sm:px-7 py-4 sm:py-5 cursor-pointer list-none select-none">
                  <span className="text-sm sm:text-base font-light text-black tracking-wide pr-4" itemProp="name">
                    {item.q}
                  </span>
                  <span className="w-6 h-6 flex items-center justify-center flex-shrink-0 text-black/40 group-open:rotate-45 transition-transform duration-300">
                    <i className="ri-add-line text-lg" aria-hidden="true"></i>
                  </span>
                </summary>
                <div
                  className="px-5 sm:px-7 pb-5 sm:pb-6"
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <p className="text-sm font-extralight text-black/60 leading-relaxed tracking-wide" itemProp="text">
                    {item.a}
                  </p>
                </div>
              </details>
            ))}
          </div>
        </div>

        {/* Notes */}
        <div className="bg-gray-50 rounded-xl sm:rounded-2xl p-6 sm:p-8 border border-gray-100">
          <h3 className="text-sm sm:text-base font-light text-black mb-4 sm:mb-5 flex items-center gap-2 tracking-wide">
            <i className="ri-information-line text-[#C4787A] text-lg" aria-hidden="true"></i>
            キャンペーンに関する注意事項
          </h3>
          <ul className="space-y-2.5 sm:space-y-3">
            {notes.map((note, idx) => (
              <li key={idx} className="flex items-start gap-2.5">
                <span className="text-[#C4787A] mt-0.5 flex-shrink-0 text-xs" aria-hidden="true">•</span>
                <span className="text-xs sm:text-sm font-extralight text-black/55 leading-relaxed tracking-wide">{note}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
